export {
  DegreeCardSimple,
  type DegreeCardSimpleProps,
} from './DegreeCardSimple';
export {
  degreeCardSimpleVariants,
  type DegreeCardSimpleVariantProps,
} from './degree-card-simple.variants';
